import { Injectable } from '@angular/core';
import { OrigamiResponse, ServiceBase } from './base/service.base';
import { Observable } from 'rxjs';
import { Topic, TopicField } from '@app/origami-api/utils/topic-utils';
import { SSUEssentialDocument } from '@app/origami-api/services/essential-documents.service';

export namespace CommunicationLogServiceOptions {
  export interface GetCommunicationLogs {
    limit?: number;
    parentId: number;
    siteId: number;
    start?: number;
    viewFilter?: string;
    viewMode: number;
    orderBy?: string;
    searchQuery?: string;
  }
}

export namespace CommunicationLogServiceModel {
  export interface SingleCommunicationLog {
    AmendmentProfileId?: number;
    CreatedBy?: number;
    EssentialFor?: SSUEssentialDocument.EssentialFor;
    EssentialForId?: string | number;
    ParentId: number;
    SiteId: number;
    TopicFields: TopicField[];
    TopicId: number;
    TopicName: number;
    TopicTypeId: number;
  }

  export interface CommunicationLogs {
    CommunicationLogs: SingleCommunicationLog[];
    TotalRowCount: number;
  }

  export interface CommunicationLogCreation {
    communicationLog: SingleCommunicationLog;
  }

  export interface CommunicationLogDelete {
    communicationLogTopics: Topic[];
    siteId: string;
  }

  export enum CommunicationLogViewMode {
    all = 1,
    byEntityProfile = 2,
    byCommunicationType = 4,
    byDate = 3,
  }

  export interface GetCommunicationLogViews {
    siteId: number;
    viewMode: CommunicationLogViewMode;
    searchTextGetter?: () => string;
  }

  export interface CommunicationLogView {
    ViewFilterDisplayName: string;
    ViewFilterId: string;
    ViewMode: number;
    EntitiesCount: number;
  }
}

@Injectable()
export class CommunicationLogService extends ServiceBase {
  serviceUrl = 'CommunicationLogService.svc';

  getCommunicationLogViews(
    body: CommunicationLogServiceModel.GetCommunicationLogViews,
    ...params
  ): Observable<OrigamiResponse<CommunicationLogServiceModel.CommunicationLogView[]>> {
    return this.origamiPost('/GetCommunicationLogViews', body, ...params);
  }

  getCommunicationLogs(
    body: CommunicationLogServiceOptions.GetCommunicationLogs,
    ...params
  ): Observable<OrigamiResponse<CommunicationLogServiceModel.CommunicationLogs>> {
    return this.origamiPost('/GetCommunicationLogs', body, ...params);
  }

  getCollaborationReview(body, ...params) {
    return this.origamiPost('/GetCollaborationReview', body, ...params);
  }

  createCommunicationLogs(
    body: CommunicationLogServiceModel.CommunicationLogCreation,
    ...params
  ): Observable<OrigamiResponse<CommunicationLogServiceModel.CommunicationLogs>> {
    return this.origamiPost('/CreateCommunicationLog', body, ...params);
  }

  deleteCommunicationLog(body: CommunicationLogServiceModel.CommunicationLogDelete, ...params) {
    return this.origamiPost('/DeleteCommunicationLog', body, ...params);
  }

  modifyCommunicationLog(
    body: CommunicationLogServiceModel.CommunicationLogCreation,
    ...params
  ): Observable<OrigamiResponse<CommunicationLogServiceModel.CommunicationLogs>> {
    return this.origamiPost('/ModifyCommunicationLog', body, ...params);
  }
}
